import { useRef, useState } from 'react';
import QrCodeDialog from './dialogs/qr-code-dialog';
import { useToast } from '../contexts/toast-context';
import { QRCode } from '@progress/kendo-react-barcodes';
import { exportImage } from '@progress/kendo-drawing';

interface QRLinkProps {
  title?: string;
  url?: string;
  activityName?: string;
}

export const QRLink = ({ ...props }: QRLinkProps) => {
  const [isOpenQR, setIsOpenQR] = useState<boolean>(false);
  const { onToastOpen } = useToast();
  const anchor = useRef<HTMLButtonElement>(null);
  const qrCodeRef = useRef<QRCode>(null);

  const handleDownload = () => {
    if (qrCodeRef.current) {
      const visual = qrCodeRef.current.exportVisual();
      exportImage(visual)
        .then((dataUri) => {
          const link = document.createElement('a');
          let fileNamePrefix = '';
          if (props.title) {
            let cleanTitle = props.title.replace(/qr\s*code/i, '').trim();
            cleanTitle = cleanTitle.replace(/[\+\-]*$/, '').trim(); // Remove trailing + or -
            fileNamePrefix =
              cleanTitle
                .replace(/[^a-zA-Z0-9\s-]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-')
                .toLowerCase() + '-';
          }
          let activityNamePart = '';
          if (props.activityName) {
            activityNamePart =
              props.activityName
                .replace(/[^a-zA-Z0-9\s-]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-')
                .toLowerCase() + '-';
          }

          link.download = `${fileNamePrefix}${activityNamePart}qrcode.png`;
          link.href = dataUri;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => {
          console.error('Failed to download QR Code', err);
        });
    }
  };

  return (
    <>
      <div className="d-flex flex-row bd-highlight mb-3">
        <div
          className={
            'd-flex align-items-center justify-items-between text-break'
          }>
          <a target={'_blank'} href={props.url}>
            {`${props.url}`}
          </a>
          <span
            className={
              'material-symbols-outlined ml-1 text-primary cursor-pointer'
            }
            ref={anchor}
            onClick={() => {
              navigator.clipboard.writeText(`${props?.url}`);
              onToastOpen({
                style: 'success',
                title: '',
                body: <div>URL copied.</div>
              });
            }}>
            content_copy
          </span>
          <span
            className="material-symbols-outlined ml-1 text-primary cursor-pointer"
            onClick={() => setIsOpenQR(true)}
            title="Show QR Code">
            qr_code_scanner
          </span>
          <span
            className="material-symbols-outlined ml-1 text-primary cursor-pointer"
            onClick={handleDownload}
            title="Download QR Code">
            download
          </span>
        </div>
      </div>
      <div style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}>
        <QRCode
          ref={qrCodeRef}
          size={350}
          value={`${props.url}`}
          errorCorrection="M"
        />
      </div>
      {isOpenQR && (
        <QrCodeDialog
          title={props.title ?? ''}
          url={props.url ?? ''}
          activityName={props.activityName}
          onClose={() => setIsOpenQR(false)}
        />
      )}
    </>
  );
};
